window.Sparkle ??= {};

window.Sparkle.Config = {
  SEOFieldsManager: {
    selectors: {
      content: window.SparkleConfig.seo.analysisTarget,
    },
    sparkleLinkPattern: window.SparkleConfig.seo.sparkleLinkPattern,
    metadataPattern: window.SparkleConfig.seo.metadataPattern,
    thumbnailAspectRatio: window.SparkleConfig.seo.thumbnailAspectRatio,
  },
  social: {
    facebook: {
      id: (window.SparkleConfig.social.facebook || {}).id,
      name: (window.SparkleConfig.social.facebook || {}).name,
      location: (window.SparkleConfig.social.facebook || {}).location,
    },
  },
};
